import React from 'react';
import { isMobile } from 'react-device-detect';

import Cabecalho from 'Component/Admin/Cabecalho';
import Video from 'Component/Video';
import { useRecuperarUnidadeDeAprendizagemQuery } from 'View/Service/Default/UnidadesDeAprendizagem';

const Default = (): React.ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: { unidade_de_aprendizagem } = {} } =
    useRecuperarUnidadeDeAprendizagemQuery(2);

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho titulo="Início" descricao="Seja bem-vindo ao Estude+" />
      <div className="bg-white shadow-sm rounded p-3">
        <div
          className="bg-dark position-relative"
          style={{ height: isMobile ? 400 : 550 }}
        >
          <Video
            titulo="Orientação aos conteudistas"
            url="https://cdnestudemais.estudesemfronteiras.com/unidade-de-aprendizagem/orientacao-conteudistas.mp4"
          />
        </div>
      </div>
    </div>
  );
};

export default Default;
